import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=08e01037&scoped=true&"
import script from "./pageHeader.js?vue&type=script&lang=js&"
export * from "./pageHeader.js?vue&type=script&lang=js&"
import style0 from "./pageHeader.scss?vue&type=style&index=0&id=08e01037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e01037",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VImg,VRow,VSpacer})
